<template>
  <footer class="common-footer">
    <div class="wrapper">
      <!-- <ul class="links">
                <li><a class="link" href="/">首页</a></li>
                <li><a class="link" href="/">专业服务</a></li>
                <li><a class="link" href="/">新闻中心</a></li>
                <li><a class="link" href="/">联系我们</a></li>
                <li><a class="link" href="/">关于我们</a></li>
            </ul> -->
      <div class="copyright">
        <span>武汉麦达电子有限公司</span>&nbsp;&nbsp;
        <span>Copyright&copy;{{new Date().getFullYear()}}</span>&nbsp;&nbsp;
        <a class="link" href="http://www.miitbeian.gov.cn/publish/query/indexFirst.action">鄂ICP备09008577号-17</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'common-footer',
  data () {
    return {}
  }
}
</script>

<style lang="less">
.common-footer {
  width: 100%;
  background-color: #333;
  font-size: 12px;
  .wrapper {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .links {
    display: flex;
    justify-content: center;
    margin: 20px 0 10px 0;
    li {
      height: 14px;
      line-height: 14px;
      padding: 0 20px;
      border-right: 1px solid #ccc;
      &:last-child {
        border-right: none;
      }
    }
  }
  .copyright {
    height: 30px;
    line-height: 30px;
    color: #ccc;
  }
  .link {
    color: #ccc;
    &:hover {
      color: #fff;
    }
  }
}
@media screen and (max-width: 768px) {
  .common-footer {
    .wrapper {
      height: 50px;
    }
    .copyright {
      height: 20px;
      line-height: 20px;
      font-size: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonFooter.vue